import { render, staticRenderFns } from "./SignatureError.vue?vue&type=template&id=0a2d041e&scoped=true&"
import script from "./SignatureError.vue?vue&type=script&lang=js&"
export * from "./SignatureError.vue?vue&type=script&lang=js&"
import style0 from "./SignatureError.vue?vue&type=style&index=0&id=0a2d041e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d041e",
  null
  
)

export default component.exports